export default __webpack_public_path__ + "static/media/hans.7828a355.png";